import axios from "axios";

import { adminUrl, PAGES, SET_PAGE } from "../config/constants";

const resetPassword = (values) => async (dispatch, getState) => {
  dispatch({
    type: "SET_LOADING",
    payload: true,
  });

  dispatch({
    type: "RESET_PWD_ERROR",
    payload: false,
  });

  const { id } = getState().resetPassword;

  const formData = new FormData();

  formData.append("action", "checkCodeEmail");
  formData.append("id", id);
  formData.append("pms_password", values.reset_pass);
  formData.append("forgot_password_code", values.code);

  const { data } = await axios.post(adminUrl, formData);

  dispatch({
    type: "SET_LOADING",
    payload: false,
  });

  if (data.result === 0) {
    dispatch({
      type: "RESET_PWD_ERROR",
      payload: true,
    });

    return;
  }

  dispatch({
    type: "RESET_PWD",
  });

  dispatch({
    type: SET_PAGE,
    payload: PAGES.LOGIN,
  });
};

export default resetPassword;



// WEBPACK FOOTER //
// ./src/actions/resetPassword.actions.js